<template>
  <div class="category">
    {{ categoryName }}
  </div>
</template>

<script>
export default {
  name: "PostListItemCategory",
  props: {
    categoryName: {
      type: String,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
.category {
  position: absolute;
  top: $spacing * 2;
  left: 0;
  @include font-size(12px);
  color: $primary;
  font-weight: 400;
  text-align: center;
  background-color: #fff;
  border-radius: 0px 16px 16px 0px;
  padding: $spacing * 0.5 $spacing * 2 $spacing * 0.375;
}
</style>
